import PropTypes from 'prop-types';
import React from 'react';

class Title extends React.PureComponent {
  static displayName = 'TourPage-About-Title';

  static propTypes = {
    name: PropTypes.string.isRequired,
  };

  render() {
    return (
      <h1 className="TourPage-About-title" data-testid="tour-page-about-title">
        {this.props.name}
      </h1>
    );
  }
}

export default Title;
